<!--
 * @Author: wangyueqi
 * @Date: 2024-10-18 15:15:30
 * @LastEditors: wangyueqi
 * @LastEditTime: 2024-11-14 16:35:39
 * @Description: 
-->
<template>
  <div class="equi">
    <div class="nav">
      <div class="navTitle">云易家智慧养老平台</div>
    </div>
    <div class="content">
      <!-- 左 -->
      <div class="content_left">
        <div class="equi_count">
          <dv-decoration-1 style="width: 100px; height: 25px" />
          <div class="equi_count_title">总数量</div>
          <div class="equi_count_num">{{ equiTotal }}</div>
        </div>
        <!-- 设备统计 -->
        <div class="equiNumBox">
          <div class="titleBox">设备统计</div>
          <div class="wrap">
            <div class="equi_img">
              <img src="@/assets/img/huan.png" alt="" class="huan" />
              <img src="@/assets/img/qiu.png" alt="" class="qiu" />
            </div>
            <div class="equi_num">
              <div class="equi_num_top">
                <div class="zaixian">
                  <div class="zaixian_title">在线设备</div>
                  <div class="zaixian_num">{{ numberList.online }}</div>
                </div>
                <div class="lixian">
                  <div class="lixian_title">离线设备</div>
                  <div class="lixian_num">{{ numberList.notonline }}</div>
                </div>
              </div>
              <dv-decoration-10
                v-if="delaty"
                style="width: 90%; height: 5px; margin: 0 auto"
              />
              <div class="equi_num_bottom">
                <div class="bindUser">
                  <div class="bindUser_title">绑定设备</div>
                  <div class="bindUser_num">{{ numberList.bing }}</div>
                </div>
                <div class="bindAddress">
                  <div class="bindAddress_title">绑定安装点</div>
                  <div class="bindAddress_num">{{ numberList.mountpoint }}</div>
                </div>
                <div class="unbindUser">
                  <div class="unbindUser_title">未绑定设备</div>
                  <div class="unbindUser_num">{{ numberList.notbing }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 设备类型 -->
        <div class="equiTypeBox">
          <div class="titleBox">设备类型占比</div>
          <eqyi-type
            style="width: 100%; height: 100%"
            :equiData="equiData"
            v-if="equiData.length"
          />
        </div>
        <div class="bindEquiNumBox">
          <div class="titleBox">每日绑定用户量</div>
          <bind-user-chart
            style="width: 100%; height: 100%"
            v-if="bindUserData.length"
            :bindUserData="bindUserData"
            :bindUservalData="bindUservalData"
          />
        </div>
      </div>
      <div class="content_center">
        <dv-border-box-1>
          <MapChart
            ref="myMap"
            style="width: 100%; height: 100%; position: relative; z-index: 888"
            @showInfo="showInfo"
          />
        </dv-border-box-1>
        <transition name="el-zoom-in-top">
          <dv-border-box-13 v-if="showSosInfo">
            <div class="centerSosBox">
              <img
                src="@/assets/img/close.png"
                alt=""
                @click="showSosInfo = false"
              />
              <div class="centerSos_item">
                <div class="sosLabel">报警时间:</div>
                <div class="sosInfoText">{{ sosInfoData.createTime }}</div>
              </div>
              <div class="centerSos_item">
                <div class="sosLabel">报警来源:</div>
                <div class="sosInfoText">
                  {{ sosInfoData.deviceType == "watch" ? "手表" : "报警器" }}
                </div>
              </div>
              <div class="centerSos_item">
                <div class="sosLabel">报警类型:</div>
                <div class="sosInfoText">{{ sosInfoData.sosType || "-" }}</div>
              </div>
			  <div class="centerSos_item">
			    <div class="sosLabel">用户ID:</div>
			    <div class="sosInfoText">
			      {{ sosInfoData.uid || "-" }}
			    </div>
			  </div>
			  <div class="centerSos_item">
			    <div class="sosLabel">用户姓名:</div>
			    <div class="sosInfoText">
			      {{ sosInfoData.elderlyName || "-" }}
			    </div>
			  </div>
			  <div class="centerSos_item">
			    <div class="sosLabel">SOS号码:</div>
			    <div class="sosInfoText">
			      {{ sosInfoData.sosPhone || "-" }}
			    </div>
			  </div>
              <div class="centerSos_item">
                <div class="sosLabel">报警地址:</div>
                <div class="sosInfoText">
                  {{ sosInfoData.sosAddress || sosInfoData.elderlyResidential+sosInfoData.detailedAddress}}
                </div>
              </div>
              <!-- <div class="centerSos_item">
                <div class="sosLabel">报警内容:</div>
                <div class="sosInfoText">
                  {{ sosInfoData.sosDetail || "-" }}
                </div>
              </div> -->
              <div class="centerSos_item" v-if="sosInfoData.isHandle">
                <div class="sosLabel">处理状态:</div>
                <div class="sosInfoText">已处理</div>
              </div>
              <div
                class="disposeBtn"
                v-else
                @click="dispose(sosInfoData.sosId)"
              >
                处理
              </div>
            </div>
          </dv-border-box-13>
        </transition>
      </div>
      <!-- 右 -->
      <div class="content_right">
        <!-- 跳转按钮 -->
        <div class="btnBox">
          <div class="equiBtn">设备</div>
          <div class="userInfoBtn" @click="$router.push('/user')">用户</div>
          <div class="orderBtn" @click="$router.push('/order')">服务订单</div>
          <div class="manageBtn">管理平台</div>
        </div>
        <div class="sosBox">
          <div class="titleBox">设备报警</div>
          <div class="sosInfo">
            <div class="sosHeader">
              <div class="daySos">
                <div class="daySos_title">今日报警</div>
                <div class="daySos_num">{{ TodaySosNotIsHandle }}</div>
              </div>

              <div class="sosIcon">
                <img src="@/assets/img/sos.png" alt="" />
              </div>
              <div class="daySos">
                <div class="daySos_title">今日处理</div>
                <div class="daySos_num">{{ TodaySosIsHandle }}</div>
              </div>
            </div>
            <!-- <div class="selectBox">
              <el-select
                v-model="value"
                placeholder="全部类型"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="item in sosOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div> -->
            <div class="sosTable">
              <el-table
                :data="tableData"
                height="90%"
                style="width: 100%"
                @cell-click="clickCell"
              >
                <el-table-column label="来源" align="center">
                  <template slot-scope="scope">
                    {{
                      scope.row.deviceType == "watch" ? "手表" : "报警器"
                    }}</template
                  >
                </el-table-column>
                <!-- <el-table-column
                  prop="sosDetail"
                  label="报警内容"
                  align="center"
                  show-overflow-tooltip
                >
                </el-table-column> -->
				<el-table-column prop="uid" label="用户ID" align="center">
				</el-table-column>
				<el-table-column
				  prop="elderlyName"
				  label="用户姓名"
				  align="center"
				  show-overflow-tooltip
				>
				</el-table-column>
				<el-table-column
				  prop="sosPhone"
				  label="SOS号码"
				  align="center"
				  show-overflow-tooltip
				>
				</el-table-column>
                <el-table-column
                  prop="sosType"
                  label="报警类型"
                  align="center"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column width="100" label="上报时间" align="center">
                  <template slot-scope="scope"
                    >{{ scope.row.createTime.split(" ")[0] }}<br />{{
                      scope.row.createTime.split(" ")[1]
                    }}</template
                  >
                </el-table-column>
                <el-table-column width="100" label="状态" align="center">
                  <template slot-scope="scope" v-if="scope.row.createTime">{{
                    scope.row.isHandle ? "已处理" : "未处理"
                  }}</template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div class="sosTypeBox">
          <div class="titleBox">报警类型</div>
          <sos-type
            :sosTypeData="sosType"
            v-if="sosType.length"
            style="width: 100%; height: 100%; position: relative; z-index: 888"
          />
        </div>
      </div>
      <div></div>
    </div>
  </div>
</template>

<script>
import bindUserChart from "../components/bindUserChart.vue";
import EqyiType from "../components/eqyiType.vue";
import MapChart from "../components/map.vue";
import SosType from "../components/sosType.vue";
import { onSosUpdate } from "../until/sosMonitor";
import { stopAlarmSound } from "../until/alarmSound";
//import { unlockAlarmSound, playAlarmSound } from "../until/alarmSound";
export default {
  components: { bindUserChart, EqyiType, MapChart, SosType },
  data() {
    return {
      showMap: false,
      equiTotal: "",
      TodaySosIsHandle: "", //已处理
      TodaySosNotIsHandle: "", //未处理
      numberList: "",
      mapData: [], //地图
      equiData: [], //设备占比
      bindUserData: [], //绑定用户
      bindUservalData: [], //绑定用户
      equiData: [], //设备占比
      sosType: [], //报警类型占比
      sosInfoData: {},
      delaty: false,
      showSosInfo: false,
      value: "",
      tableData: [],
      //knownSosIds: {},
      //sosListInitialized: false,
      sosOptions: [
        {
          value: "0",
          label: "跌倒报警",
        },
        {
          value: "1",
          label: "2222",
        },
        {
          value: "2",
          label: "2222",
        },
        {
          value: "3",
          label: "2222",
        },
      ],
    };
  },
  created() {
	let token = localStorage.getItem("mytoken");
	console.log(token);
	if(!token){
		//跳转到登录页
		this.$router.push("/login");
	}
    this.getDevicesTypeProportion();
    this.getDailyBindUsers();
    this.getNumber();
    this.getSostype();
    this.SosList();
    // this.getMapDataDetails();
    // SosList 改由全局监控广播驱动, 这里只轮询设备数量
    setInterval(() => {
      this.getNumber();
      //this.SosList();
    }, 10000);
  },
  methods: {
    dispose(id) {
        //  console.log(this.$refs)
      let params = {
        id: id,
      };
      // 先手动静掉当前报警声(包括 mp3 和 preset), 避免处理完还在耳边响
      stopAlarmSound();
      this.$http.updateSosHandleOnSosld({ params }).then((res) => {
        // console.log("处理", res);
        // if(res.data.code==200){
        //   // this.sosInfoData=res.data.data
        // }
     
        this.$refs.myMap.getMapDataDetails();
        this.SosList();
        this.getOneDateFromSos(id);
      });
    },
    //获取sos详情
    getOneDateFromSos(id) {
      let params = {
        id: id,
      };
      this.$http.getOneDateFromSos({ params }).then((res) => {
        // console.log("sos详情", res);
        if (res.data.code == 200) {
          this.sosInfoData = res.data.data;
        }
      });
    },
    //获取地图数据
    getMapDataDetails() {
      this.showMap = false;
      // console.log(123456789);
      this.$http.getMapDataDetails().then((res) => {
        // console.log("地图数据", res);

        if (res.data.code == 200) {
          this.mapData = res.data.data;
        }
        this.showMap = true;
      });
    },
    /*checkNewSosAlarm(list) {
      if (!Array.isArray(list)) {
        return;
      }
      const newUnhandled = list.filter((item) => {
        const id = item.sosId;
        if (id == null || this.knownSosIds[id]) {
          return false;
        }
        return !item.isHandle;
      });
      list.forEach((item) => {
        if (item.sosId != null) {
          this.knownSosIds[item.sosId] = true;
        }
      });
      if (!this.sosListInitialized) {
        this.sosListInitialized = true;
        return;
      }
      if (newUnhandled.length > 0) {
        playAlarmSound();
      }
    },*/
    //获取sos列表(仅展示, 响铃由全局监控负责)
    SosList() {
      this.$http.SosList().then((res) => {
        // console.log("sos列表", res);
        if (res.data.code == 200) {
          /*const list = res.data.data.Soslist || [];
          this.checkNewSosAlarm(list);
          this.tableData = list;
          this.equiTotal = res.data.data.total;
          this.TodaySosNotIsHandle = res.data.data.TodaySosNotIsHandle;
          this.TodaySosIsHandle = res.data.data.TodaySosIsHandle;*/
          this.applySosData(res.data.data);
        }
      });
    },
    //应用sos数据到页面
    applySosData(data) {
      this.tableData = (data && data.Soslist) || [];
      this.equiTotal = data.total;
      this.TodaySosNotIsHandle = data.TodaySosNotIsHandle;
      this.TodaySosIsHandle = data.TodaySosIsHandle;
    },
    // 报警类型占比
    getSostype() {
      this.$http.getSostype().then((res) => {
        // console.log("报警类型占比", res);
        if (res.data.code == 200) {
          this.sosType = res.data.data;
        }
      });
    },
    // 设备数量占比
    getDevicesTypeProportion() {
      this.$http.getDevicesTypeProportion().then((res) => {
        if (res.data.code == 200) {
          this.equiData = res.data.data;
        }
      });
    },
    //每日绑定用户
    getDailyBindUsers() {
      this.$http.getDailyBindUsers().then((res) => {
        if (res.data.code == 200) {
          //  this.equiData =res.data.data
          // console.log("每日绑定用户", res);
          if (res.data.code == 200) {
            this.bindUserData = res.data.data.chartData;
            this.bindUservalData = res.data.data.chartDataval;
          }
        }
      });
    },
    getNumber() {
      this.$http.getNumber().then((res) => {
        // console.log("在线设备", res);
        if (res.data.code == 200) {
          this.numberList = res.data.data;
        }
      });
    },
    showInfo(data) {
      this.showSosInfo = true;
      // console.log("接收", this.mapData[data]);
      this.getOneDateFromSos(data);
    },
    clickCell(data) {
      this.showSosInfo = true;
      // console.log("点击单元格", data);
      this.sosInfoData = data;
    },
  },
  mounted() {
    //document.addEventListener("click", unlockAlarmSound, { once: true });
    // 订阅全局 SOS 监控广播, 刷新表格与计数
    this.unsubSos = onSosUpdate((data) => {
      this.applySosData(data);
    });
    setTimeout(() => {
      this.delaty = true;
    }, 500);
  },
  beforeDestroy() {
    if (this.unsubSos) {
      this.unsubSos();
    }
  },
};
</script>

<style scoped>
</style>
<style lang='scss' scoped>
.disposeBtn {
  margin-top: vw(10);
  width: vw(70);
  height: vw(40);
  line-height: vw(40);
  text-align: center;
  border-radius: vw(4);
  background: #1de9b6;
  color: #fff;
  cursor: pointer;
}
::v-deep .el-select-dropdown {
  background: rgba(12, 35, 97);
  border: none !important; /* 确保边框被移除 */
  box-shadow: none !important; /* 移除阴影 */
}

::v-deep .el-select-dropdown__item {
  color: #fff !important;
  background-color: transparent;
}
::v-deep .el-select-dropdown__item.hover,
::v-deep .el-select-dropdown__item:hover {
  color: #fff;
  background: rgba(16, 30, 93, 1) !important;
}
::v-deep .el-scrollbar__wrap {
  // overflow-x: hidden;//将横向滚动条隐藏
  /* 修改滚动条颜色 */
  scrollbar-color: #909399 #fff; /* 滚动条滑块颜色 滚动条背景颜色 */

  /* 修改滚动条宽度 */
  scrollbar-width: thin; /* 可以是 'auto', 'thin', 'none' */
}
::v-deep .el-scrollbar__thumb {
  //可设置滚动条颜色
  background: transparent; //这里我设置成了透明色,可以根据需求添加自己想要的颜色
}

@keyframes rotate {
  from {
    transform: rotate(0deg); /* 从 0 度开始旋转 */
  }
  to {
    transform: rotate(360deg); /* 旋转到 360 度 */
  }
}
@keyframes rotate2 {
  from {
    transform: rotate(360deg); /* 从 0 度开始旋转 */
  }
  to {
    transform: rotate(0deg); /* 旋转到 360 度 */
  }
}
.titleBox {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  background-image: url("@/assets/img/titleBg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: vw(200);
  height: vw(50);
  line-height: vw(40);
  color: rgb(25, 236, 255);
  font-size: vw(18);
  text-align: center;
  letter-spacing: vw(5);
}
.equi {
  box-sizing: border-box;
  overflow: hidden;
  padding: 0 vw(10) vw(20);
  background: url("@/assets/bg.png") no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  box-sizing: border-box;
  .nav {
    box-sizing: border-box;
    padding-top: vw(10);
    margin: 0 auto;
    width: 100%;
    height: 7%;
    background-image: url("@/assets/img/headerbg2.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: relative;
    top: vw(-10);
    .navTitle {
      height: 80%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 1) 37.41%,
        rgba(180, 207, 242, 1) 100%
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      text-align: center;
      font-size: vw(30);
      letter-spacing: vw(2);
      font-weight: 600;
    }
  }
  .content {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    flex: 1;
    height: 90%;
    // padding-bottom: 1%;
    .content_left {
      position: relative;
      width: 23%;
      height: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      ::v-deep .dv-decoration-1 {
        position: absolute;
        top: vw(10);
        right: 15%;
      }
      .equi_count {
        position: relative;
        display: flex;
        align-items: center;
        background-image: url("@/assets/img/userCount.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        width: 100%;
        height: 14%;
        color: rgba(0, 216, 255, 1);
        font-size: vw(30);
        .equi_count_title {
          width: vw(120);
          margin-left: vw(70);
          margin-right: vw(20);
        }
        .equi_count_num {
          margin-right: vw(70);
          flex: 1;
          text-align: right;
          background: linear-gradient(
            180deg,
            rgba(247, 254, 255, 1) 17.52%,
            rgba(123, 205, 235, 1) 57.82%,
            rgba(25, 111, 143, 1) 100%
          );
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        // background: red;
      }
      .equiNumBox {
        padding: 0 vw(20);
        position: relative;
        margin-top: 3%;
        background-image: url("@/assets/img/border1.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        height: 25%;
        .wrap {
          padding-top: vw(10);
          height: 100%;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          display: flex;
        }
        .equi_img {
          position: relative;
          width: 25%;
          .huan {
            width: 100%;
            animation: rotate 3s infinite linear;
          }
          .qiu {
            animation: rotate2 3s infinite linear;
            position: absolute;
            width: 55%;
            top: vw(31);
            left: vw(22);
          }
        }
        .equi_num {
          flex: 1;
          .equi_num_top {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: vw(8);
          }
          .zaixian,
          .lixian {
            width: 48%;
            text-align: center;
            color: #fff;
          }
          .zaixian_num {
            color: rgb(10, 193, 142);
            font-size: vw(18);
            font-weight: 500;
          }
          .lixian_num {
            color: rgb(7, 182, 213);
            font-size: vw(18);
            font-weight: 500;
          }
          .equi_num_bottom {
            margin-top: vw(8);
            display: flex;
            justify-content: space-between;
            .bindUser,
            .unbindUser,
            .bindAddress {
              width: 33%;
              color: #fff;
              text-align: center;
            }
            .bindUser_num {
              color: rgb(237, 147, 93);
              font-size: vw(18);
              font-weight: 500;
            }
            .unbindUser_num {
              color: rgb(115, 163, 255);
              font-size: vw(18);
              font-weight: 500;
            }
            .bindAddress_num {
              color: #ef6f6f;
              font-size: vw(18);
              font-weight: 500;
            }
          }
        }
        .equiNumBox {
        }
      }
      .equiTypeBox {
        width: 100%;
        background-image: url("@/assets/img/border1.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        height: 28%;
        margin-top: 4%;
        position: relative;
      }
      .bindEquiNumBox {
        position: relative;
        width: 100%;
        background-image: url("@/assets/img/border1.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        height: 28%;
        margin-top: 4%;
      }
    }
    .content_center {
      border-radius: vw(34);
      position: relative;
      width: 54%;
      height: 95%;
      margin: 0 vw(16);
      background: rgba(16, 30, 93, 0.5);
      ::v-deep .dv-border-box-13 {
        padding: vw(20);
        position: absolute;
        bottom: vw(30);
        left: vw(30);
        width: vw(250);
        height: vw(300);
        z-index: 999;
      }
      .centerSosBox {
        position: relative;
        font-size: vw(16);
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        background: rgba(9, 109, 217, 0.9);
        padding: vw(20);
        padding-top: vw(50);
        // border: 1px solid rgba(106, 190, 246, 1);

        box-shadow: inset 0px 0px 10px rgb(124, 165, 197);
        border-radius: vw(8);
        img {
          cursor: pointer;
          width: vw(28);
          position: absolute;
          top: vw(5);
          right: vw(5);
        }
        .centerSos_item {
          margin-bottom: vw(6);
          display: flex;
          color: #fff;
          align-items: center;
          .sosLabel {
            margin-right: vw(5);
            width: vw(70);
          }
          .sosInfoText {
            flex: 1;
            word-break: break-all;
            /* 或者 */
            overflow-wrap: break-word;
            line-height: 1;
          }
        }
        //  background: pink;
      }
    }
    .content_right {
      width: 23%;
      height: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: space-between;
      ::v-deep .el-table .el-table__row {
        cursor: pointer !important;
        background: rgba(14, 95, 255, 0.1) !important;
      }
      ::v-deep .el-table .el-table__row:nth-of-type(2n) {
        cursor: pointer !important;
        background: rgba(14, 95, 255, 0.2) !important;
      }
      .btnBox {
        height: 6.5%;
        width: 100%;
        display: flex;
        justify-content: center;
        .userInfoBtn,
        .manageBtn,
        .equiBtn,
        .orderBtn{
          font-size: vw(16);
          letter-spacing: vw(5);
          font-weight: 600;
          cursor: pointer;
          z-index: 99;
          width: 25%;
          background-image: url("@/assets/img/btnLineHeight.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #fff;
        }
        .manageBtn,
        .userInfoBtn,
        .orderBtn{
          background-image: url("@/assets/img/btnLine.png");
        }
      }
      .sosBox {
        box-sizing: border-box;
        padding-top: vw(50);
        width: 100%;
        position: relative;
        background-image: url("@/assets/img/border1.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        height: 55%;
        .sosInfo {
          display: flex;
          // align-items: center;
          flex-direction: column;
          width: 100%;
          height: 100%;

          .sosHeader {
            width: 100%;
            height: 20%;
            display: flex;
            color: #fff;
            align-items: flex-end;
            text-align: center;
            justify-content: center;
            .daySos {
              width: 33%;
              .daySos_num {
                color: #ef6f6f;
                font-size: vw(18);
              }
            }
          }
        }
        .selectBox {
          width: 40%;
          display: flex;
          ::v-deep input {
            background: transparent;
            border: none;
            min-width: 115px;
            color: #fff;
          }
        }

        .sosTable {
          flex: 1;
          width: 90%;
          margin: 0 auto;

          /*去除底边框*/
          ::v-deep.el-table td.el-table__cell {
            border: 0;
          }
          ::v-deep.el-table th.el-table__cell.is-leaf {
            border: 0;
          }
          /*去除底部灰条.el-table::before*/
          ::v-deep .el-table::before {
            display: none;
          }
          /*最外层透明*/
          ::v-deep .el-table,
          ::v-deep .el-table__expanded-cell {
            background-color: transparent !important;
          }
          /* 表格内背景颜色 */
          ::v-deep .el-table th,
          ::v-deep .el-table td {
            background-color: transparent !important;
            border: 0; //去除表格
            color: #fff;
          }
          ::v-deep .el-table thead tr {
            background-color: transparent !important;
            border: 0; //去除表格
            color: #fff;
          }

          // 滚动条的宽度
          ::v-deep .el-table__body-wrapper::-webkit-scrollbar {
            width: vw(8); // 横向滚动条
            height: vw(8); // 纵向滚动条 必写
          }
          // 滚动条的滑块
          ::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
            background-color: rgba(16, 30, 93, 0.8); //颜色
            -webkit-box-shadow: inset 0 0 vw(5) #122a47;
            // background: #122A47;
            border-radius: vw(5); //圆角
          }
          ::v-deep .el-table__body-wrapper::-webkit-scrollbar-track {
            -webkit-box-shadow: inset 0 0 vw(5) #122a47;
            border-radius: 0;
            // background: #122a47;
          }
        }

        .sosIcon {
          position: relative;
          top: -20%;
          width: 33%;
          margin-top: vw(10);
          width: vw(60);
          height: vw(60);
          img {
            width: 100%;
          }
        }
      }
      .sosTypeBox {
        width: 100%;
        position: relative;
        background-image: url("@/assets/img/border1.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        height: 35%;
      }
      // background: #fff;
    }
  }
}
</style>